module.exports = __webpack_public_path__ + "media/images/flags/64/England-397144b91d6ba2bfdbf9c18eb00aa6d7.png";